<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
  #app{position: relative}
  #he-plugin-simple .s-sticker-city{
    padding-left: 20px !important;
  }

  .collapse-list-box .el-collapse .el-collapse-item:nth-child(odd){
    background-color:#F5F5F5;
    border-left: 6px solid #366;
  }
  .collapse-list-box .el-collapse .el-collapse-item:nth-child(even){
    background-color:#fff;
    border-left: 6px solid #fff;
  }
  .el-collapse-item__wrap{
    background:none;
  }
  .el-collapse-item__header{
    background:none;
  }

  .swiper-container-3d .swiper-slide-shadow-left{
    background-image: linear-gradient(to left,rgb(0,0,0,0),rgba(0,0,0,0)) !important;
  }
  .swiper-container-3d .swiper-slide-shadow-right{
    background-image: linear-gradient(to right,rgba(0,0,0,0),rgba(0,0,0,0)) !important
  }


  .swiper-wzjq-pagination{
    margin-top: 50px;
    width: 100%;
  }
  .swiper-wzjq-pagination .swiper-pagination-bullet{
    width: 20px !important;
    height: 20px !important;
    margin-left: 10px !important;
    background-color: #00B197 !important;
    opacity: 1 !important;
  }
  .swiper-wzjq-pagination .swiper-pagination-bullet-active{
    background-color: #b44343 !important;
  }


  .font-12{font-size: 12rem}
  .font-14{font-size: 14rem}
  .font-16{font-size: 16rem}
  .font-18{font-size: 18rem}
  .font-20{font-size: 20rem}
  .font-22{font-size: 22rem}
  .font-24{font-size: 24rem}
  .font-26{font-size: 26rem}
  .font-28{font-size: 28rem}
  .font-30{font-size: 30rem}
  .font-32{font-size: 32rem}
  .font-34{font-size: 34rem}
  .font-36{font-size: 36rem}
  .font-38{font-size: 38rem}
  .font-40{font-size: 40rem}
  .font-42{font-size: 42rem}
  .font-44{font-size: 44rem}
  .font-46{font-size: 46rem}
  .font-48{font-size: 48rem}
  .font-50{font-size: 50rem}
</style>



// WEBPACK FOOTER //
// src/App.vue